<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient3 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(122, 211, 141, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(122, 211, 141, 0.25)");
    this.gradient.addColorStop(1, "rgba(122, 211, 141, 1)");
    

    this.gradient2.addColorStop(0, "rgba(255, 187, 86, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(255, 187, 86, 0.25)");
    this.gradient2.addColorStop(1, "rgba(255, 187, 86, 1)");

    this.gradient3.addColorStop(0, "rgba(232, 99, 99, 1)");
    this.gradient3.addColorStop(0.5, "rgba(232, 99, 99, 0.25)");
    this.gradient3.addColorStop(1, "rgba(232, 99, 99, 1)");

    


    this.renderChart(
      {
        labels: ["Завершенные", "Проверяется", "Не сдан"],
        datasets: [
          {
            backgroundColor: [this.gradient, this.gradient2, this.gradient3],
            data: [40, 20, 10]
          }
        ]
      },
      { 
        responsive: true, 
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      }
    );
  }
};
</script>